import {Component, Input, OnInit} from '@angular/core';
import {ContactPensionProductsPreviewModel} from '../contact-pension-products-preview-model';

@Component({
  selector: 'cf-pension-reserve-preview',
  templateUrl: './pension-reserve-preview.component.html',
  styleUrls: ['./pension-reserve-preview.component.scss'],
})
export class PensionReservePreviewComponent implements OnInit {

  @Input()
  model: ContactPensionProductsPreviewModel;
  @Input()
  showBar = true;
  @Input()
  showText = true;

  constructor() {
  }

  ngOnInit(): void {
  }

}
